import { render, staticRenderFns } from "./DropdownSelect.vue?vue&type=template&id=1516471e&scoped=true&"
import script from "./DropdownSelect.vue?vue&type=script&lang=js&"
export * from "./DropdownSelect.vue?vue&type=script&lang=js&"
import style0 from "./DropdownSelect.vue?vue&type=style&index=0&id=1516471e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1516471e",
  null
  
)

export default component.exports